import http from "../../utils/http-common";
import { useQuery } from "@tanstack/react-query";
import type { CatalogProcedure as Catalog } from "../../interfaces";

export function useCatalogProcedure() {
  const getCatalogProcedure = async (): Promise<Catalog[]> => {
    const response = await http.get<Catalog[]>("/service_procedure/catalog");
    return response.data;
  };

  return useQuery<Catalog[]>({
    queryKey: ["catalog_procedure"],
    queryFn: getCatalogProcedure,
  });
}
